module.exports = estNumberFilter;

/*@ngInject*/
function estNumberFilter($filter) {
    return function(number, fraction, thousandsSeparator) {
        if (!number) return '0,00';

        var ts = _.isUndefined(thousandsSeparator) ? ' ' : thousandsSeparator;
        if(fraction) {
            var numFilter = $filter('number')(parseFloat(number) , fraction);
            return numFilter.replace(',', ts).replace('.', ',');
        }

        return number;
    };
}



/** WEBPACK FOOTER **
 ** ./app/shared/filters/estnumber.filter.js
 **/